import { BankOutlined } from '@ant-design/icons';
import { TenantSwitchModal, useTenant } from '@zhiyue/core';
import React from 'react';

const TENANT_SWITCH_LABELS = {
  title: '切换企业',
  empty: '暂无可切换企业',
  switchAction: '切换企业',
  createAction: '创建/加入企业',
  deleteAction: '删除企业',
};

export const TenantSwitcher: React.FC = () => {
  const { currentTenantUuid, tenants, refreshTenants } = useTenant();
  const [tenantModalOpen, setTenantModalOpen] = React.useState(false);
  const currentTenant = tenants.find(
    (tenant) => tenant.id === currentTenantUuid,
  );

  const openModal = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setTenantModalOpen(true);
      void refreshTenants();
    },
    [refreshTenants],
  );

  if (!currentTenant) {
    return null;
  }

  const displayName = currentTenant.name;

  return (
    <>
      <button
        type="button"
        className="app-current-tenant"
        title={displayName}
        aria-label={`切换企业，当前：${displayName}`}
        onClick={openModal}
      >
        <span className="app-current-tenant-icon" aria-hidden="true">
          <BankOutlined />
        </span>
        <span className="app-current-tenant-name">{displayName}</span>
      </button>
      <TenantSwitchModal
        open={tenantModalOpen}
        onClose={() => setTenantModalOpen(false)}
        labels={TENANT_SWITCH_LABELS}
      />
    </>
  );
};
